export enum RouteNamesEnum {
  REPORTS = "/reports",
  DATASOURCES = "/data-sources",
  BLOCKS = "/blocks",
  AUTH = "/auth",
  SAMPLES = "/samples"
}
